import {Button, Input, Space, Tooltip} from "antd";
import {CustomModal} from "../../../../components/modal";
import {StyledModalContentWrapper} from "../../../../components/calls/upcoming-calls/call-card/call-card.style";
import {StyledSuccessServiceContent} from "../../../../components/calls/service/service-form/service-form.style";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {useState} from "react";
import {
  CopyOutlined,
  FacebookFilled,
  MailFilled,
  TwitterOutlined,
} from "@ant-design/icons";
import {
  handleFacebookLink,
  handleMailLink,
  handleTwitterLink,
} from "../../../../utils/products";
import {REBRAND_BASE_URL} from "../../../../services/config";

export function CreateDiscountCodeSuccessModal({
  handleOk,
  openSuccessfulModal,
  discountCode,
}: {
  openSuccessfulModal: boolean;
  handleOk: () => void;
  discountCode?: string;
}) {
  const {state: profileState} = useGetProfileContext();
  const [toolTipText, setToolTipText] = useState<string>("copy code");
  return (
    <CustomModal
      visibleState={openSuccessfulModal}
      title="Discount code generated"
      okFunc={handleOk}
      cancelFunc={handleOk}
      footerContent={[
        <Button
          key="publicProfile"
          type="primary"
          href={`${REBRAND_BASE_URL}/${profileState.profileData.username}`}
          target="_blank"
          size="small"
        >
          View my public profile
        </Button>,
        <Button size="small" key="gotIt" type="default" onClick={handleOk}>
          Got it!
        </Button>,
      ]}
    >
      <StyledModalContentWrapper>
        <StyledSuccessServiceContent>
          <p className="success-text">
            Your discount code has been successfully generated! Share to your customers so
            they can enjoy discount offers during their checkout.
          </p>
          <div className="success-share-info">
            <Input.Group compact style={{display: "flex"}}>
              <Input size="large" readOnly value={discountCode ?? ""} />
              <Tooltip title={toolTipText}>
                <Button
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={() =>
                    navigator.clipboard
                      .writeText(discountCode ?? "")
                      .then(() => setToolTipText("copied"))
                  }
                />
              </Tooltip>
            </Input.Group>
            <p>or</p>
            <Space direction="horizontal" size={16}>
              <div>
                <Button
                  shape="circle"
                  size="small"
                  icon={<FacebookFilled />}
                  style={{
                    backgroundColor: "#EBEEF5",
                    color: "#3B5998",
                    border: "none",
                  }}
                  type="link"
                  target="_blank"
                  href={handleFacebookLink({
                    username: profileState.profileData.username,
                  })}
                  title="Share on facebook"
                />
              </div>
              <div>
                <Button
                  title="Share on twitter"
                  shape="circle"
                  size="small"
                  icon={<TwitterOutlined />}
                  target="_blank"
                  style={{
                    backgroundColor: "#E6F7FD",
                    color: "#00ACEE",
                    border: "none",
                  }}
                  href={handleTwitterLink({
                    textContent: `I just created a discount code`,
                    username: profileState.profileData.username,
                  })}
                />
              </div>
              <div>
                <Button
                  title="Send mail"
                  shape="circle"
                  size="small"
                  icon={<MailFilled />}
                  style={{
                    backgroundColor: "#FBECEB",
                    color: "#DB4437",
                    border: "none",
                  }}
                  href={handleMailLink({
                    subject: "I wanted you to see this site",
                    body: `Book a session with me on Coachli ${REBRAND_BASE_URL}/${profileState.profileData.username}`,
                  })}
                />
              </div>
            </Space>
          </div>
        </StyledSuccessServiceContent>
      </StyledModalContentWrapper>
    </CustomModal>
  );
}
